import { BaseRouteService } from 'core/services';

class FacilityAreaOfCareRouteService extends BaseRouteService {
    constructor() {
        super('facility-areas-of-care');
    }
 
}

export default FacilityAreaOfCareRouteService;
